
import Fan from "@/entities/fan";
import fallbackImage from "@/assets/img/no-image.png";
import { computed, defineComponent, PropType, ref } from "vue";

export default defineComponent({
  name: "ProfileIcon",
  props: {
    fan: {
      type: Object as PropType<Fan | null>,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const failedImageUri = ref("");
    const imageSource = computed(() => {
      const imageUri = props.fan?.image_uri;
      return !imageUri || imageUri === failedImageUri.value ? fallbackImage : imageUri;
    });

    function useFallbackImage() {
      failedImageUri.value = props.fan?.image_uri ?? "";
    }

    return {
      imageSource,
      useFallbackImage,
    };
  },
});
